export const TranslationLanguageCode = Object.freeze({
  TW: 'zh-TW',
  CN: 'zh-CN',
  JP: 'ja-JP',
  TH: 'th-TH',
  EN: 'en-US'
})

export const I18nLocaleCode = Object.freeze({
  TW: 'zh-TW',
  CN: 'zh-CN',
  JP: 'ja',
  TH: 'th-TH',
  EN: 'en-US',
  MY: 'ms-MY'
})
